<div style="margin-bottom: 12px;">
  <div
  #tabla
  class="table-container"
  *ngIf="!loader"
  >
    <div
      class="table-heads"
      *ngIf="!loader && array.length"
      [ngStyle]="table_config.styles.table_heads"
    >
      <span *ngFor="let name of table_config.tableHeads">
        {{ name[0] }}
        <i
          class="bi bi-arrow-down-up"
          *ngIf="table_config.filter"
          (click)="ordenar(name[1])"
          style="cursor: pointer"
        ></i>
      </span>
      <div class="container-icons" [ngStyle]="table_config.styles.container_icons">
        <span *ngFor="let name of table_config.tableHeadsContainer">{{
          name
        }}</span>
      </div>
    </div>
    <div
      class="table-row"
      [id]="assignId(item)"
      [ngStyle]="table_config.styles.table_row"
      [ngClass]="[selectLastItem(item) ,subtotalRow(item)]"
      *ngFor="let item of array | sort : campoOrdenar : isAscending : groupByField : totalField : subtotalField: totalPiecesField"
    >
      <ng-container *ngFor="let name of table_config.arrayFields">
        <app-status
          [text]="item[name]"
          [color]="appointmentColor(item[name])"
          *ngIf="name === 'status_description'"
        ></app-status>
        <app-status
          [text]="item[name]"
          [color]="appointmentColor(item[name])"
          *ngIf="name === 'status_description_asipona'"
        ></app-status>
        <app-status
          [text]="item[name]"
          [color]="seleccionarColor(item[name])"
          *ngIf="name === 'batch_status'"
        ></app-status>
        <app-status
          [color]="seleccionarColorEntrada(item[name])"
          *ngIf="name === 'batch_status_id'"
        ></app-status>
        <app-status
          [color]="seleccionarColorFactura(item[name])"
          [text]="item[name] === false ? 'Pendiente' : 'Creada' "
          *ngIf="name === 'generated'"
        ></app-status>
        <app-status
          [color]="seleccionarColorPedimento(item[name])"
          [text]="item[name] === false ? 'No' : 'Si' "
          *ngIf="name === 'cancelled'"
        ></app-status>
        <app-status
          [color]="seleccionarColorAbandono(item[name])"
          *ngIf="name === 'abandonment_status'"
        ></app-status>
        <app-status
          [color]="seleccionarColorSincronizacion(item[name])"
          *ngIf="name === 'synchronization_status'"
        ></app-status>
        <app-status
          [color]="seleccionarColorPedimento(item[name])"
          *ngIf="name === 'rectification'"
        ></app-status>
        <app-status
          [color]="seleccionarColorSincronizacion(item[name])"
          *ngIf="name === 'locations_status' && item[name] !== undefined"
        ></app-status>
        <span *ngIf="name === 'bl_tonnage'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'output_tonnage'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'remaining_tonnage'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'total'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'output_tons'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'remaining_tons'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'input_tons'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'tonnage'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'total_weight'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'total_tonnage'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'tons_released'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'gross_weight'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'tare_weight'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'net_weight'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'origin_weight'">{{
          item[name] | number : "1.3-3"
        }}</span>
        <span *ngIf="name === 'total_pieces'">{{
          item[name] | number
        }}</span>
        <span *ngIf="name === 'big_bags'">{{
          item[name] | number
        }}</span>
        <span *ngIf="name === 'start_operations' || name === 'sampling_date'">{{
          item[name] | date : "dd/MM/yyyy HH:mm"
        }}</span>
        <span *ngIf="name === 'date'">{{
          item[name] | date : "dd/MM/yyyy"
        }}</span>
        <span *ngIf="name === 'end_operations'">{{
          item[name] | date : "dd/MM/yyyy HH:mm"
        }}</span>
        <span *ngIf="name === 'departure_date'">{{
          item[name] | date : "dd/MM/yyyy"
        }}</span>
        <span *ngIf="name === 'admission_date'">{{
          item[name] | date : "dd/MM/yyyy"
        }}</span>
        <span *ngIf="name === 'customs_entry_payment_date'">{{
          item[name] | date : "dd/MM/yyyy"
        }}</span>
        <span *ngIf="name === 'abandonment_date' || name === 'undocking_date' || name === 'date_origin_weight'">{{
          item[name] === '' || item[name] === null || item[name] === undefined ?
          'No asignada.' :
          item[name] | date : "dd/MM/yyyy"
        }}</span>
        <span *ngIf="name === 'merchandise_abandonment_percentage'">{{
          item[name]
        }} %</span>
        <span title="{{ item[name] }}" *ngIf="name !== 'sampling_date' && name !== 'output_tonnage' && name !== 'status_description' && name !== 'status_description_asipona' && name !== 'locations_status' && name !== 'date_origin_weight' && name !== 'synchronization_status' && name !== 'undocking_date' && name !== 'abandonment_date' && name !== 'rectification' && name !== 'customs_entry_payment_date' && name !== 'big_bags' && name !== 'total_pieces' && name !== 'origin_weight' && name !== 'gross_weight' && name !== 'tare_weight' && name !== 'net_weight' && name !== 'batch_status_id' && name !== 'batch_status' && name !== 'bl_tonnage' && name !== 'remaining_tonnage' && name !== 'total' && name !== 'abandonment_status' && name !== 'output_tons' && name !== 'input_tons' && name !== 'remaining_tons' && name !== 'tonnage' && name !== 'total_weight' && name !== 'total_tonnage' && name !== 'tons_released' && name !== 'start_operations' && name !== 'date' && name !== 'end_operations' && name !== 'departure_date' && name !== 'admission_date' && name !== 'merchandise_abandonment_percentage' && name !== 'generated' && name !== 'cancelled'">{{
          item[name]
        }}</span>
      </ng-container>
      <div
        class="container-icons"
        [ngStyle]="table_config.styles.container_icons"
        [ngClass]="{'hide-buttons': subtotalRow(item) === 'subtotal-row'}"
      >
        <ng-container *ngFor="let icono of table_config.iconos">
          <a
            *ngIf="
              icono[0] !== '/lote-eliminar' &&
              icono[0] !== '/detalle-salida' &&
              icono[0] !== '/actualizar-salida' &&
              icono[0] !== '/eliminar-salida' &&
              icono[0] !== '/detail-entry' &&
              icono[0] !== '/update-entry' &&
              icono[0] !== '/descargar-salida' &&
              icono[0] !== '/print-output' &&
              icono[0] !== '/actualizar-abandono' &&
              icono[0] !== '/eliminar-abandono' &&
              icono[0] !== '/detalle-export-entry' &&
              icono[0] !== '/actualizar-export-entry' &&
              icono[0] !== '/eliminar-entry-export' &&
              icono[0] !== '/descargar-pedimento' &&
              icono[0] !== '/detalle-entrada' &&
              icono[0] !== '/detail-bill' &&
              icono[0] !== '/actualizar-entrada'
            "
            (click)="navigateTo(icono[0], item[icono[1]])"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/lote-eliminar'"
            (click)="ouputInfoLote(item.operation_number, item.registry_number)"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/detalle-salida'"
            (click)="outputDetalleSalida(item.id, item.output_type_option_id)"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/detalle-entrada'"
            (click)="detalleEntrada(item.id, item.input_type_id)"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/actualizar-entrada'"
            (click)="actualizarEntrada(item.id, item.input_type_id)"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/actualizar-salida'"
            (click)="outputActualizarSalida(item.id, item.output_type_option_id)"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/eliminar-salida'"
            (click)="outputEliminarSalida(item.id, item.output_type_option_id)"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/detail-entry'"
            (click)="exportEntryDetail(item.id, item[icono[1]])"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/update-entry'"
            (click)="exportUpdateDetail(item.id, item[icono[1]])"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/descargar-salida'"
            (click)="outputDescargarSalida(item.id, item.output_type_option_id)"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/print-output'"
            (click)="outputPrintOutput(item.id, item.output_type_option_id)"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/actualizar-abandono'"
            (click)="outputActualizarAbandono(item[icono[1]])"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/eliminar-abandono'"
            (click)="outputEliminarAbandono(item[icono[1]])"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/descargar-pedimento'"
            (click)="outputDescargarPedimento(item[icono[1]])"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/detalle-export-entry'"
            (click)="outputDetalleEntryExport(item[icono[1]])"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/actualizar-export-entry'"
            (click)="outputActualizarEntryExport(item[icono[1]])"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/eliminar-entry-export'"
            (click)="outputEliminarEntryExport(item[icono[1]])"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
          <a
            *ngIf="icono[0] === '/detail-bill'"
            (click)="outputDetailBill(item[icono[1]])"
          >
            <i [ngClass]="icono[2]"></i>
          </a>
        </ng-container>
      </div>
    </div>
    <div
      class="table-row"
      [ngStyle]="table_config.styles.table_row_totals"
      *ngIf="!loader && array.length && table_config.totals.show"
    >
      <ng-container *ngFor="let item of table_config.totals.content">
        <span *ngIf="item === ''"></span>
        <span *ngIf="item === 'Totales:'">Totales({{array.length}}):</span>
        <span *ngIf="item === 'total'">{{ table_config.totals.total | number : "1.3-3" }}</span>
        <span *ngIf="item === 'total_output'">{{ table_config.totals.total_output | number : "1.3-3" }}</span>
        <span *ngIf="item === 'total_remaining'">{{ table_config.totals.total_remaining | number : "1.3-3" }}</span>
        <span *ngIf="item === 'total_percent'">{{ table_config.totals.total_percent | number : "1.3-3" }} %</span>
        <span *ngIf="item === 'totalOriginWeight'">{{ table_config.totals.totalOriginWeight | number : "1.3-3" }}</span>
        <span *ngIf="item === 'totalGrossWeight'">{{ table_config.totals.totalGrossWeight | number : "1.3-3" }}</span>
        <span *ngIf="item === 'totalTareWeight'">{{ table_config.totals.totalTareWeight | number : "1.3-3" }}</span>
        <span *ngIf="item === 'totalNetWeight'">{{ table_config.totals.totalNetWeight | number : "1.3-3" }}</span>
        <span *ngIf="item === 'piezas'">{{ table_config.totals.piezas | number }}</span>
      </ng-container>
    </div>
    <app-empty-state
      *ngIf="!array.length && !loader"
      [mensaje]="table_config.mensaje"
    ></app-empty-state>
  </div>
</div>
<app-loader class="loader" *ngIf="loader"></app-loader>
<app-overlay
  icono="bi bi-info-circle-fill"
  mensaje="Sin autorización para esta acción."
  *ngIf="isAuthorized"
></app-overlay>
